import React from 'react';
import { format } from 'date-fns';

import { DayColumn } from './DayColumn';
import { HoverCard } from './HoverCard';
import { CalendarEvent, EventColorSet, EventsByDate } from 'pages/Agenda/utils';
import { useWeekView } from '../../../hooks/useWeekView';
import { Grid } from '../styled';

interface WeekViewProps {
  weekDays: Date[];
  events: EventsByDate;
  horasPrevistasByDate: Record<string, string>;
  isCompletedView: boolean;
  onNavigateByDay?: (direction: 'prev' | 'next') => void;
  onCardClick: (event: CalendarEvent, colorSet: EventColorSet) => void;
}

export const WeekView: React.FC<WeekViewProps> = ({
  weekDays,
  events,
  horasPrevistasByDate,
  isCompletedView,
  onNavigateByDay,
  onCardClick,
}) => {
  const { hoveredCard, setHoveredCard, isDragging, getColorSet } = useWeekView();

  return (
    <>
      <Grid>
        {weekDays.map((day, index) => (
          <DayColumn
            key={day.toISOString()}
            date={day}
            dayIndex={index}
            events={events[format(day, 'yyyy-MM-dd')] || []}
            horasPrevistasLabel={horasPrevistasByDate[format(day, 'yyyy-MM-dd')] ?? '00:00h'}
            onCardHover={setHoveredCard}
            onCardLeave={() => setHoveredCard(null)}
            onCardClick={onCardClick}
            isDragging={isDragging}
            getColorSet={getColorSet}
            isCompletedView={isCompletedView}
            onNavigateByDay={onNavigateByDay}
          />
        ))}
      </Grid>
      {hoveredCard && <HoverCard {...hoveredCard} isCompletedView={isCompletedView} />}
    </>
  );
};
